import api from "./api";
import endpoints from "./endpoints";

export default {
  get(languages) {
    return api
      .get(endpoints.attributeManager.globalAttributes.get, {
        params: { languages }
      })
      .then((x) => Promise.resolve(x.data));
  },
  update(model) {
    return api.post(endpoints.attributeManager.globalAttributes.update, model).then((x) => Promise.resolve(x.data));
  },
  delete(items) {
    return api.post(endpoints.attributeManager.globalAttributes.delete, items).then((x) => Promise.resolve(x.data));
  },
  savedeepLTranslated: async function (model, sourceLanguage) {
    return api
      .post(endpoints.attributeManager.globalAttributes.deepL, model, { params: { sourceLanguage: sourceLanguage } })
      .then((x) => Promise.resolve(x.data));
  },
  getDetails: async function (language, attributeIds) {
    const response = await api.post(endpoints.attributeManager.globalAttributes.details, attributeIds, {
      params: { language }
    });
    return response.data;
  }
};
